module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_5010.697341ad.png";